import React from 'react';
import { useSelector } from 'react-redux';
import CardKeyValue from '../../../../card/cardKeyValue';
import { getObjectCurriculumElementsDR } from '../../utils';
import TextFormatDateRange from '../../../../text/TextFormatDateRange';

const CardsInformation = () => {
  const formData = useSelector((state) => state?.dr?.form || {});
  const subjects = useSelector((state) => state?.subject?.list || []);
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const years = useSelector((state) => state?.tenant?.years || []);

  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum?.elementsStructure)
    return <></>;

  const curriculumElements = getObjectCurriculumElementsDR(
    currentCurriculum?.elements,
    currentCurriculum?.elementsStructure,
    formData?.curriculumElements || {}
  );

  const subject = subjects.find((item) => item._id === formData.subjectId);
  const yearLevel = formData.yearLevel?.map((item) => years.find((year) => year._id === item)?.name);

  return (
    <div className='flex flex-nowrap gap-4 pb-4 items-strech justify-center overflow-auto'>
      {curriculumElements.element && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title={curriculumElements.element.keyName}
          value={curriculumElements.element.valueName}
        />
      )}
      {curriculumElements.subElement && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title={curriculumElements.subElement.keyName}
          value={curriculumElements.subElement.valueName}
        />
      )}
      {subject && (
        <CardKeyValue
          className='min-w-100px max-w-150px'
          lines={2}
          title='Subject'
          value={subject.name || ''}
        />
      )}
      <CardKeyValue className='min-w-100px max-w-150px' lines={2} title='Name' value={formData.name || ''} />
      <CardKeyValue
        className='min-w-100px max-w-150px'
        lines={2}
        title='Year level'
        value={yearLevel?.join(', ') || ''}
      />
      <CardKeyValue
        className='min-w-130px max-w-130px'
        title='Period'
        tooltip={false}
        value={
          <TextFormatDateRange
            colorText={formData?.linkedClasses?.length > 0 ? 'text-accent' : 'text-primary opacity-50'}
            className='text-sm text-center'
            startDate={formData.startDate}
            endDate={formData.endDate}
          />
        }
      />
    </div>
  );
};

export default CardsInformation;
